import React from 'react'
import { ToolbarSection } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarSection'
import { ToolbarItem } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarItem'
import { defaultProps } from './index'

export const RowSettings = () => {
  const layoutOpts = [
    { value: 'cols', label: '2 colonne' },
    { value: 'sidebar-left', label: 'Sidebar a sinistra' },
    { value: 'sidebar-right', label: 'Sidebar a destra' },
  ]

  return (
    <ToolbarSection title="Settings" initOpen>
      <ToolbarItem
        propKey="block"
        propSubKey="layout"
        type="select"
        options={layoutOpts}
        label="Layout"
        defaultValue={defaultProps['layout']}
      />
    </ToolbarSection>
  )
}
